import styled from 'styled-components';

import PrebookingTable from './component';

export default styled(PrebookingTable)`
  width: 100%;
`;
